import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonChip, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonItemDivider, IonLabel, IonNote, IonPage, IonProgressBar, IonRow, IonSegment, IonSegmentButton, IonSpinner, IonText, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react'
import { add, arrowForward } from 'ionicons/icons'
import React, { useEffect, useState, useCallback } from 'react'
import { SafetyPadding } from '../../components/SafetyPadding'
import { goToPage } from '../../helpers/app_actions'
import { StepChallengeInterface } from './StepChallenges'
import { useSelector } from 'react-redux';
import { WalkI } from '../../interfaces/Walk'
import Api from "../../services/Api"
import { RootState } from '../../redux/reducers'
import dayjs from 'dayjs'


interface StatisticInterface {
  walks: Array<WalkI>
  created: Array<WalkI>
  booked: Array<WalkI>
  teamWalks: Array<WalkI>
}

const ChallengePage = () => {
  const walks = useSelector((state: RootState) => state.walks)
  const api = Api.getInstance()
  const [challenges, setChallenges] = useState<Array<StepChallengeInterface>>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [statistics, setStatistics] = useState<StatisticInterface>({
    walks: [],
    created: [],
    booked: [],
    teamWalks: []
  })

  const getStats = useCallback(() => {
    const booked = walks.walks.filter((walk: WalkI) => walk.booked === 1)
    const created = walks.walks.filter((walk: WalkI) => walk.editable === 1)
    const teamWalks = walks.walks.filter((walk: WalkI) => walk.teamId !== null)

    setStatistics({
      ...statistics,
      walks: walks.walks,
      booked: booked,
      created: created,
      teamWalks: teamWalks
    })
  }, [walks])

  useEffect(() => {
    getStats()
  }, [getStats])

  useEffect(() => {
    api.get('pedometer/step_challenges').then(res => {
      res.json().then(data => {
        if(data.status === 'ok') {
          setChallenges(data.challenges.filter((v: any, i: any, a: any) => a.findIndex((v2: any) =>(v2.id === v.id)) === i)) 
          setLoading(true)
        } else {
          setLoading(true)
          setError(true)
        }
      })
    })

  }, [])

  useIonViewDidEnter(() => {
    // console.log('entering')
  })

  return (
    <IonPage className="cheap_desktop">
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton/>
          </IonButtons>
          <IonTitle>{api.tr('activity_challenges')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      { loading ? 
      <IonContent>
        { error ? 
          <IonRow className="flex justify-center items-center p-2">
            <IonText>{api.tr('no_challenge')}</IonText>
          </IonRow>
        : 
        <>
          { challenges.sort((a, b) => new Date(b.start).getTime() - new Date(a.start).getTime()).map((challenge: any, key: any) => {
            let from = new Date(challenge.start)
            let to   = new Date(challenge.end)
            let check = new Date();
            let active = 'Active'
            if((check <= to && check >= from)) {
              
            } else {
              active = 'Date passed'
            }
              
            return <IonCard 
              key={'challengeList'+ key}
              className="m-2"
              onClick={() => goToPage('/walk/challenges/' + challenge.id)}>
                <IonCardHeader className="p-2">
                  <IonCardTitle mode="md" className="flex justify-between items-center">
                    {challenge.name}
                    <IonChip className="p-2" color={active === 'Active' ? 'primary' : 'medium'}>{active}</IonChip>
                  </IonCardTitle>
                  <IonCardSubtitle mode="md" >
                    {challenge.start} - {challenge.end}   
                  </IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonChip className="p-2 mr-2" color="teal">{((challenge.distanceDone / challenge.routeDistance) * 100).toFixed(1)} %</IonChip>
                  <IonProgressBar className="mt-2" value={(challenge.distanceDone / challenge.routeDistance)}></IonProgressBar>
                </IonCardContent>
              </IonCard>
              }
            )}
            <SafetyPadding/>
          </>
        }
      </IonContent> 
      : 
      <IonContent>
        <IonGrid>
          <IonRow className="flex justify-center p-4 items-center">
            <IonSpinner/>
          </IonRow>
        </IonGrid>  
      </IonContent>
      }
    </IonPage>
  )
}

export default ChallengePage
